<script>
  /* eslint-disable eqeqeq,no-return-assign */

import Layout from '@layouts/primary'
import mapboxgl from 'mapbox-gl';
import { vehicleMethods } from '@state/helpers'

export default {
  page: {
    title: 'Map',
    meta: [{ name: 'map', content: 'Map' }],
  },
  components: {
    Layout
  },
  data(){
    return{
      map: null,
      vehicles: [],
      coordsCenter: [],
      mapVehicles: {
        "type": "FeatureCollection",
        "features" : []
      },
      position:[]
    }
  },
  computed: {
  },
  created(){
    // Add tag script
    let mapBoxTag = document.createElement('script');
    mapBoxTag.setAttribute('src',"//api.tiles.mapbox.com/mapbox-gl-js/v0.52.0/mapbox-gl.js");
    document.head.appendChild(mapBoxTag);
  },
  mounted(){
    this.getVehicles().then(response => {
      let obj = this.$store.state.vehicles.objects
      for (let v in obj) {

        let feature = {
          "geometry": {
            "type": "Point",
            "coordinates": []
          },
          "properties": {
            "plate": ""
          }
        };

        // Create a copy of the object to update it
        let formattedObj = {
          ...obj[v]
        }

        // build vehicle obj with the lat and long
        // console.log('formattedObj', formattedObj)
        if(formattedObj.last_known_lon){
          feature.geometry.coordinates.push(formattedObj.last_known_lon);
        }

        if(formattedObj.last_known_lat){
          feature.geometry.coordinates.push(formattedObj.last_known_lat);
        }

        if(formattedObj.number_plate){
          feature.properties.plate = formattedObj.number_plate;
        }

        // only display trucks that have last locations
        if(feature.geometry.coordinates.length > 0)
          this.mapVehicles.features.push(feature);

        this.vehicles.push(formattedObj);
      }

      // console.log(this.vehicles)
      // Define the center coords based on number of vehicles
      // if there is more than 1
      if(this.mapVehicles.features && this.mapVehicles.features.length > 1){
        let long = (this.mapVehicles.features[0].geometry.coordinates[0] + this.mapVehicles.features[1].geometry.coordinates[0]) / 2;
        let lat = (this.mapVehicles.features[0].geometry.coordinates[1] + this.mapVehicles.features[1].geometry.coordinates[1]) / 2;

        this.coordsCenter.push(long,lat);
      }
      else if(this.mapVehicles.features && this.mapVehicles.features.length === 1){
        let long = this.mapVehicles.features[0].geometry.coordinates[0];
        let lat = this.mapVehicles.features[0].geometry.coordinates[1];

        this.coordsCenter.push(long,lat)

      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoiam9hbm5lbWFuY3VzbyIsImEiOiJjanJhNTRjcWowb200NDlwYzd3amMzNzY5In0.PXQlRcMT7zOb2YklVWZxng';

      let map = '';
      // if there is location center the map and add annotations
      if(this.coordsCenter && this.coordsCenter.length > 0){
        map = new mapboxgl.Map({
          container: 'map',
          style: 'mapbox://styles/joannemancuso/cjrb7u1k31jcg2slwfrymbg2p',
          center: this.coordsCenter,
          zoom: 10
        });

        // add markers to map
        this.mapVehicles.features.forEach(function(mapVehicles) {
          // console.log('mapVehicles', mapVehicles)
          // Only display trucks that have coordinates
          if(mapVehicles && mapVehicles.geometry.coordinates.length > 0){
            // create marker after loading map
            map.on('load', function() {
              // create a HTML element for each feature
              let el = document.createElement('div');
              el.className = 'marker';

              // make a marker for each feature and add to the map
              new mapboxgl.Marker(el)
                .setLngLat(mapVehicles.geometry.coordinates)
                .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
                  .setHTML('<h4>' + 'PLATE' + '</h4>' + mapVehicles.properties.plate))
                .addTo(map);
            });
          }
        });
      }
      else{
        map = new mapboxgl.Map({
          container: 'map',
          style: 'mapbox://styles/joannemancuso/cjrb7u1k31jcg2slwfrymbg2p',
          center: [115.1750171, -24.9859824],
          zoom: 1
        });
      }
    })
  },
  methods: {
    ...vehicleMethods,
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <h2 :class="$style.routeHeader">
        Map
      </h2>

      <VLayout
        row
        wrap
      >
        <VFlex
          xs12
          sm12
          md12
          lg12
        >
          <VCard
            :class="$style.mapCard"
          >
            <VContainer
              grid-list-md
            >
              <VLayout
                row
                wrap
              >
                <VFlex
                  xs12
                  sm12
                  md12
                  lg12
                >
                  <div id="map" />
                </VFlex>
              </VLayout>
            </VContainer>
          </VCard>
        </VFlex>
      </VLayout>

    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';
  .routeHeader {
    display: inline-block;
  }

  .mapCard {
    height: 75vh !important;
  }

  .dashcard{
    padding:15px 15px 15px 15px;
  }

  .addButton {
    display: inline-block;
    float: right;
  }

  .headline {
    font-size: 1em !important;
  }
  .card {
    height: 100%;
    padding: 10px;
  }
  .paddingCard{
    margin-left: 1em !important;
  }

</style>
